if (!window.patternTheme) {
  window.patternTheme = { colorSwatches: {}, toast: null };
}

const itemQuantityUpdated = new CustomEvent("itemQuantityUpdated");

function getFocusableElements(container) {
  return Array.from(
      container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
  );
}

function getRandomNumber(min = 1, max = 999) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function handleizeString(str) {
  return str.toLowerCase().replace(/\s+/g, "-");
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    const isOpen = event.currentTarget.closest('details').hasAttribute('open');
    event.currentTarget.setAttribute('aria-expanded', !isOpen);

    if (!summary.classList.contains('internal-menu-drawer')) {
      const header = event.currentTarget.closest('sticky-header');
      if (header) {
        if (isOpen) {
          header.removeAttribute('megamenuopen');
        } else {
          header.setAttribute('megamenuopen', '');
        }
      }
    }
  });

  if (summary.parentElement.parentElement.id === "appMegamenu") {
    summary.addEventListener('mouseenter', (event) => {
      const details = event.currentTarget.closest('details');
      const isOpen = details.hasAttribute('open');
      if (!isOpen) {
        details.setAttribute('open', '');
        event.currentTarget.setAttribute('aria-expanded', true);
        const header = event.currentTarget.closest('sticky-header');
        if (header) header.setAttribute('megamenuOpen', '');
        event.currentTarget.style = "outline: none; box-shadow: none;";
        event.currentTarget.focus();
      }
    });
  }

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function trackConversionTagEvent(type, data) {
  const conversionLabel = window.themePixels.google[`${type}ConversionLabel`];
  const eventName = window.themePixels.google[`${type}EventName`];
  const conversionId = window.themePixels.google.conversionId;

  const hasConversionTag = !!(conversionId && conversionLabel && eventName);
  if (hasConversionTag) {
    const sendTo = `${conversionId}/${conversionLabel}`;
    console.log('### eventName', eventName);
    console.log('### sendTo', sendTo);

    gtag("event", eventName, { send_to: sendTo, ...(data || {}) });
  }
}

function trackEvent(type, data) {
  if (type === 'navigation') {
    console.log('link clicked: ', data);
  }
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
        (event.target === container || event.target === first) &&
        event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function findVariantByOptions(variants, options, isCard = false) {
  let variant = variants.find((variant) => {
    const currentOptsStr = JSON.stringify(options.sort());
    const variantOptsStr = JSON.stringify(variant.options.sort());
    return currentOptsStr === variantOptsStr;
  });

  if(!variant && !isCard) {
    variant = variants.find((variant) => {
      if(variant.option1 == options[1] && variant.available) {
        return true;
      } else if (variant.option1 == options[0] && variant.available) {
        return true;
      }
    });
  }

  return variant;
}

function reloadYotpo() {
  try {
    yotpoWidgetsContainer.initWidgets()
  } catch (e) {}
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();

    if (this.countryEl.parentNode instanceof SelectDropdown) {
      this.countryEl.parentNode.reset();
    }
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";

      if (this.provinceEl.parentNode instanceof SelectDropdown) {
        this.provinceEl.parentNode.reset();
      }
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 1023px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        if(!parentMenuElement.classList.contains('mobile-facets--vertical')) {
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
        }
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 1023px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this, false)
    );
    this.parseUrl = this.getAttribute('data-page-url');
    if(this.parseUrl) {
      this.parseContent();
    }
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  parseContent() {
    fetch(`${this.parseUrl}`)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data, 'text/html');
        const mainContent = htmlDoc.querySelector('#MainContent');
        this.querySelector('.product-popup-modal__content-info').innerHTML = mainContent.innerHTML;
      })
      .catch(error => {
        console.error(error);
      });
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);
class SelectDropdown extends HTMLElement {
  constructor() {
    super();
    this.defineDropdownTarget();
  }

  connectedCallback() {
    if (this.dropdownTarget) {
      this.init();
    }
  }

  defineDropdownTarget() {
    this.dropdownTarget = this;
  }

  init() {
    this.style();
    if(!this.dropdownTarget) return;
    const selectDropdownEl = this.dropdownTarget.querySelector("select");
    if(!selectDropdownEl) return;
    if (!selectDropdownEl.disabled) {
      this.bindEvents();
    }
  }

  reset() {
    this.cleanUp();
    this.defineDropdownTarget();
    this.init();
  }

  cleanUp() {}

  cleanUpStyles() {
    const selectedItemDiv =
        this.dropdownTarget.querySelector(".select-selected");
    const selectListDiv = this.dropdownTarget.querySelector(".select-items");
    selectedItemDiv.remove();
    selectListDiv.remove();
  }

  style() {
    // create selected element
    if(!this.dropdownTarget) return;
    const selectDropdownEl = this.dropdownTarget.querySelector("select");
    if(!selectDropdownEl) return;

    if(this.dropdownTarget.querySelector('.select-items')) {
      this.cleanUpStyles()
    }

    const selectDropdownOptions = Array.from(selectDropdownEl.options);
    const selectedItemDiv = document.createElement("div");
    selectedItemDiv.setAttribute("role", "button");
    selectedItemDiv.setAttribute("class", "select-selected t-body-small");
    selectedItemDiv.setAttribute("tabindex", "0");
    const options = Array.from(selectDropdownEl.options);
    const selectedOption = options[selectDropdownEl.selectedIndex ? selectDropdownEl.selectedIndex : 0];
    const activeHTML = selectedOption ? selectedOption.innerHTML : '---';
    selectedItemDiv.innerHTML = this.getSelectInnerHTML(selectDropdownEl);
    const arrow = document.createElement("div");
    arrow.classList.add('arrow');
    arrow.innerHTML = window.themeIcons.arrowDown;
    selectedItemDiv.appendChild(arrow);

    this.dropdownTarget.appendChild(selectedItemDiv);
    // create hidden element to properly handle select size based in largest select option
    const sizeHolder = this.createSizeHolder(selectDropdownEl);
    this.dropdownTarget.appendChild(sizeHolder);

    // disable select behavior if disabled
    if (selectDropdownEl.disabled) {
      this.dropdownTarget.setAttribute("disabled", "");
      return;
    }

    // create select list
    const selectListDiv = document.createElement("div");
    selectListDiv.setAttribute("role", "listbox");
    selectListDiv.setAttribute("tabindex", "0");
    selectListDiv.setAttribute("aria-activedescendant", "");
    selectListDiv.setAttribute("class", "select-items select-hide");
    for (const optionIndex in selectDropdownOptions) {
      // create each select item
      const option = selectDropdownEl.options[optionIndex];
      const selectOptionDiv = document.createElement("div");
      selectOptionDiv.setAttribute("role", "option");
      selectOptionDiv.setAttribute("class", "t-body-small");
      selectOptionDiv.setAttribute("tabindex", "0");
      selectOptionDiv.innerHTML = option.innerHTML;
      if (+optionIndex === selectDropdownEl.selectedIndex) {
        selectOptionDiv.setAttribute("class", "t-body-small same-as-selected");
      }

      if (option.selected) {
        selectListDiv.setAttribute("aria-activedescendant", option.id);
      }

      selectListDiv.appendChild(selectOptionDiv);
    }
    this.dropdownTarget.appendChild(selectListDiv);
  }

  bindEvents() {
    if(!this.dropdownTarget) return;
    const selectedItemDiv =
        this.dropdownTarget.querySelector(".select-selected");
    const selectDropdownEl = this.dropdownTarget.querySelector("select");
    const selectListDiv = this.dropdownTarget.querySelector(".select-items");
    if(!selectDropdownEl) return;

    // bind element interactions (mouse click, search and enter to open the select)
    selectedItemDiv.addEventListener(
        "click",
        onSelectedItemDivClick.bind(this)
    );
    selectedItemDiv.addEventListener(
        "keydown",
        onSelectedItemDivKeydown.bind(this)
    );
    selectedItemDiv.addEventListener("keydown", onTextSearch.bind(this));
    selectListDiv.addEventListener("keydown", onTextSearch.bind(this));

    const selectOptionsDivs = Array.from(selectListDiv.querySelectorAll("div[role='option']"));

    const optionsCleanUps = selectOptionsDivs.map((selectOptionDiv, index) => {
      // bind specific item interactions (mouse click and enter to select an element)
      selectOptionDiv.addEventListener("click", onOptionSelected.bind(this));
      selectOptionDiv.addEventListener("keydown", onOptionKeydown.bind(this));
      selectOptionDiv.addEventListener("keydown", onTextSearch.bind(this));

      // return cleanUp function to remove events on element destroy
      return cleanUp;

      function onOptionKeydown(e) {
        if (e.key === "Enter") {
          onOptionSelected.bind(this).call();
          selectedItemDiv.focus();
        } else if (e.key === "Escape") {
          this.toggleSelectListInSelectDropdown(this);
          selectedItemDiv.focus();
        }
      }
      function onOptionSelected() {
        this.selectItemInSelectDropdown(
            this.dropdownTarget,
            selectDropdownEl,
            selectListDiv,
            selectOptionDiv,
            selectedItemDiv,
            index
        );
      }
      function cleanUp() {
        selectOptionDiv.removeEventListener("click", onOptionSelected);
        selectOptionDiv.removeEventListener("keydown", onOptionKeydown);
      }
    });
    // bind select dropdown outside click
    document.addEventListener("click", onOutsideClick);

    // bind select dropdown event change to global change
    selectDropdownEl.addEventListener('change', () => this.dispatchEvent(new Event("change")));

    // define cleanUp function
    this.cleanUp = cleanUp;

    function onSelectedItemDivClick(event) {
      event.stopPropagation();
      this.toggleSelectListInSelectDropdown(this);
    }
    function onSelectedItemDivKeydown(e) {
      const isDropdownClosed = selectListDiv.classList.contains("select-hide");

      if (e.key === "Enter" || (e.key === "ArrowDown" && isDropdownClosed)) {
        this.toggleSelectListInSelectDropdown(this.dropdownTarget);
        selectListDiv.querySelector("div").focus();
      }
    }
    function onTextSearch(e) {
      const item = selectOptionsDivs.find((item) => item.innerHTML[0].toLowerCase() === e.key.toLowerCase());
      if (item) item.focus();
    }
    function onOutsideClick(e) {
      const hasClickedInElement = [
        this.dropdownTarget,
        selectedItemDiv,
        selectListDiv,
      ].includes(e.target);
      if (!hasClickedInElement) {
        selectListDiv.classList.add("select-hide");
        if(selectListDiv.closest('.select-dropdown')) selectListDiv.closest('.select-dropdown').classList.remove("show-select");
        selectedItemDiv.classList.remove("active");
      }
    }
    function cleanUp() {
      selectedItemDiv.removeEventListener("click", onSelectedItemDivClick);
      selectedItemDiv.removeEventListener("keydown", onSelectedItemDivKeydown);
      document.removeEventListener("click", onOutsideClick);
      for (const optionCleanUp of optionsCleanUps) {
        optionCleanUp();
      }
      this.cleanUpStyles();
    }
  }

  getSelectInnerHTML(select) {
    const options = Array.from(select.options);
    const selectedOption = options[select.selectedIndex ? select.selectedIndex : 0];
    const activeHTML = selectedOption ? selectedOption.innerHTML : '---';
    const arrow = document.createElement("div");
    arrow.classList.add('arrow');
    arrow.innerHTML = window.themeIcons.arrowDown;

    return `<span>${activeHTML + arrow.outerHTML}</span>`;
  }

  removeClassFromChildEls(target, classSelector) {
    const childList = Array.from(target.getElementsByTagName("*"));
    for (const child of childList) {
      child.classList.remove(classSelector);
    }
  }

  createSizeHolder(select) {
    const sizeHolder = document.createElement("div");
    sizeHolder.setAttribute("class", "size-holder");
    const options = Array.from(select.options);
    const innerHTML = options.reduce(
        (acc, option) => acc + `<div>${option.innerHTML}</div>`,
        ""
    );
    sizeHolder.innerHTML = innerHTML;

    return sizeHolder;
  }

  toggleSelectListInSelectDropdown(selectDropdown) {
    const selectListDiv = selectDropdown.querySelector(".select-items");
    const selectedItemDiv = selectDropdown.querySelector(".select-selected");

    if (selectListDiv.classList.contains("select-hide")) {
      selectListDiv.classList.remove("select-hide");
      selectListDiv.closest('.select-dropdown').classList.add("show-select");
      selectedItemDiv.classList.add("active");
    } else {
      selectListDiv.classList.add("select-hide");
      if(selectListDiv.closest('.select-dropdown')) selectListDiv.closest('.select-dropdown').classList.remove("show-select");
      selectedItemDiv.classList.remove("active");
    }
  }

  selectItemInSelectDropdown(
      selectDropdown,
      selectDropdownEl,
      selectListDiv,
      selectOptionDiv,
      selectedItemDiv,
      optionIndex
  ) {
    this.removeClassFromChildEls(selectListDiv, "same-as-selected");
    selectDropdownEl.selectedIndex = optionIndex;
    selectOptionDiv.classList.add("same-as-selected");
    selectedItemDiv.innerHTML = this.getSelectInnerHTML(selectDropdownEl);

    const options = Array.from(selectDropdownEl.options);

    for (const optIndex in options) {
      const option = options[optIndex];
      if (+optIndex === +optionIndex) {
        option.setAttribute("selected", "selected");
        selectListDiv.setAttribute("aria-activedescendant", option.id);
      } else {
        option.removeAttribute("selected");
      }
    }

    selectDropdownEl.dispatchEvent(new Event("change"));

    this.toggleSelectListInSelectDropdown(selectDropdown);
  }
}

customElements.define("select-dropdown", SelectDropdown);

class VariantSelects extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.onVariantChange);
    this.querySelectorAll('select-dropdown').forEach((selectDropdownEl) => {
      selectDropdownEl.addEventListener('change', this.onVariantChange.bind(this));
    });
    if(this.closest('.pdp__wrapper').querySelector('.gallery-update')) {
      this.querySelector('color-picker').addEventListener('mouseover', (e) => {
        if(e.target.tagName.toLowerCase() === 'input') {
          let customOptions = this.updateColorOptions(e.target);
          let customVariant = this.getVariantForGallery(customOptions)
          this.updateMedia(customVariant);
          this.renderProductGallery(customVariant);
        }
      })
    }
    this.hideDisabledVariants();
    this.initIconWithText();
  }

  hideDisabledVariants() {
    let handle = this.dataset.productHandle;

    fetch(`${window.Shopify.routes.root}products/${handle}.js`).then(
        (res) => res.json()
    ).then((rawProduct) => {
      this.product = this.getEnhancedProduct(rawProduct);
      this.selectedVariant = this.getSelectedVariant();

      this.product.options.forEach((option) => {
        const optionId = `#optionPicker${option.name}`;
        const optionEl = this.querySelector(optionId);

        const optionValues = optionEl.querySelectorAll('input');
        Array.from(optionValues).forEach((optionValue) => {
          const optionName = optionValue.getAttribute('name');
          const value = optionValue.getAttribute('value');
          const type = optionValue.dataset.type;
          const optionPrediction = this.predictOption(optionName, value);
          if (optionPrediction.hide) {
            if (type === 'color-picker') {
              const label = optionValue.closest('label.outer-wrapper');
              label.style.display = 'none';
            }

            if (type === 'radio-picker') {
              const parent = optionValue.closest('.radio-item');
              parent.style.display = 'none';
            }

            if(type === 'color-picker-pill') {
              const label = optionValue.nextElementSibling;
              label.style.display = 'none';
            }
          }
        });

        if (optionEl.classList.contains('select-dropdown')) {
          const selectEl = optionEl.querySelector('select');
          const selectItems = optionEl.querySelectorAll('.select-items div');
          const optionName = selectEl.getAttribute('name');

          Array.from(selectItems).forEach((optionValue) => {
            const value = optionValue.textContent.trim();

            const optionPrediction = this.predictOption(optionName, value);
            if (optionPrediction.hide) {
              optionValue.style.display = 'none';
            }
          });
        }
      })
    });
  }

  getEnhancedProduct(rawProduct) {
    // maps metafields to variants
    const variantsMetafields = this.getJsonData(`mainProductVariantsPatternThemeMetafields`);

    return {
      ...rawProduct,
      variants: rawProduct.variants.map((variant) => ({
        ...variant,
        metafields: variantsMetafields[variant.id],
      })),
    };
  }

  getSelectedVariant() {
    if (!this.product) {
      return null;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const selectedVariantId = searchParams.get('variant');

    if (selectedVariantId) {
      return Array.from(this.product.variants).find((variant) => {
        return variant.id === +selectedVariantId;
      });
    }

    let notHidden = this.product.variants.filter((variant) => {
      return !variant.metafields.hide_variant;
    });
    let notHiddenAvailable = notHidden.filter((variant) => {
      return variant.available;
    });
    console.log('notHiddenAvailable: ', notHiddenAvailable[0])
    
    return notHiddenAvailable[0];
  }

  getJsonData(id) {
    const strData = this.querySelector(`[data-id="${id}"]`);
    return strData ? JSON.parse(strData.innerHTML) : {};
  }

  predictOption(optionName, value) {
    const predictedOptions = this.product.options.map((option) => {
      if (option.name === optionName) {
        return value;
      }
      return this.selectedVariant.options.find((opt) =>
          option.values.includes(opt)
      );
    });

    const predictedVariant = findVariantByOptions(
        this.product.variants,
        predictedOptions
    );

    if(predictedVariant && this.selectedVariant) {
      return {
        available: predictedVariant.available,
        priceDiff: predictedVariant.price - this.selectedVariant.price,
        hide: !!predictedVariant.metafields.hide_variant
      };
    } else {
      return {
        available: false,
        priceDiff: false,
        hide: false
      }
    }
  }

  resetSelectDropdown() { }

  onVariantChange(e) {
    let currentVariantPicker = e.target.closest('.js-variant-picker')

    if (currentVariantPicker) {
      let stateOfPickers = true
      currentVariantPicker.dataset.selected = 'true'

      if (e.target.dataset.type === 'color-picker') {
        e.target.closest('.outer-wrapper').classList.add('active')
      }

      this.variantPickers = document.querySelectorAll('.js-variant-picker')
      this.variantPickers.forEach(variantPicker => {
        if (variantPicker.dataset.selected === 'false') {
          stateOfPickers = false
        }
      })

      if (!stateOfPickers) return;
    }

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      if(this.dataset.urlUpd != 'false') {
        this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    this.initIconWithText();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    const radios = this.querySelectorAll('input[type="radio"]');
    const radioOptions = Array.from(radios).reduce((acc, radio) => {
      if (radio.checked) return [...acc, radio.value];
      return acc;
    }, []);
    this.options = [...this.options, ...radioOptions];
  }

  updateColorOptions(el) {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    const radios = this.querySelectorAll('input[type="radio"]');
    const radioOptions = Array.from(radios).reduce((acc, radio) => {
      if (radio.checked) return [...acc, radio.value];
      return acc;
    }, []);
    let checkedOption = el.closest('color-picker').querySelector('input:checked').getAttribute('value')
    let optionsToUpdate = [...this.options, ...radioOptions];
    const index = optionsToUpdate.indexOf(checkedOption);

    if (index !== -1) {
      optionsToUpdate[index] = el.getAttribute('value');
    }
    return optionsToUpdate;
  }

  updateMasterId() {
    const variants = this.getVariantData();
    this.currentVariant = findVariantByOptions(variants, this.options);
  }

  getVariantForGallery(customOptions) {
    const variants = this.getVariantData();
    return findVariantByOptions(variants, customOptions);
  }

  updateMedia(customVariant) {
    let thisVariant = this.currentVariant;

    if(customVariant) {
      thisVariant = customVariant;
    }
    if (!thisVariant) return;
    if (!thisVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(thisVariant.featured_media.id));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${thisVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductGallery(customVariant) {
    let thisVariant = this.currentVariant;

    if(customVariant) {
      thisVariant = customVariant;
    }


    fetch(`${this.dataset.url}?variant=${thisVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          const selectorsToUpdate = ['.gallery-update']

          selectorsToUpdate.forEach((selector) => {
            const source = html.querySelector(selector);
            const destination = document.querySelector(selector);

            if (source && destination) {
              destination.outerHTML = source.outerHTML;
            }
          });
        });
  }

  renderProductInfo(customVariant) {
    let thisVariant = this.currentVariant;

    if(customVariant) {
      thisVariant = customVariant;
    }

    fetch(`${this.dataset.url}?variant=${thisVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          const selectorsToUpdate = ['.pdp__wrapper']

          selectorsToUpdate.forEach((selector) => {
            const source = html.querySelector(selector);
            const destination = document.querySelector(selector);

            if (source && destination) {
              destination.outerHTML = source.outerHTML;
            }
          });

          const price = document.getElementById(`price-${this.dataset.section}`);

          if (price) price.classList.remove('visibility-hidden');
          this.toggleAddButton(!thisVariant.available, window.variantStrings.soldOut);
          this.resetSelectDropdown();
          if(this.dataset.urlUpd != 'false') {
            window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
          }
          reloadYotpo();
        });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.classList.add('b-secondary');
      addButton.classList.remove('b-primary');

      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.classList.add('b-primary');
      addButton.classList.remove('b-secondary');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || this.getJsonData('mainProductVariants');
    return this.variantData;
  }

  initIconWithText() {
    const iconWithText = document.querySelectorAll('.icon-with-text__item');

    iconWithText.forEach((item) => {
      const tooltip = item.querySelector('.text-tooltip');
      if (tooltip) {
        item.addEventListener('mousemove', (event) => {
          const tooltipWidth = tooltip.offsetWidth;
          const windowWidth = window.innerWidth;

          if (!isTouchDevice()) {
            item.style.position = 'static';
            tooltip.style.display = 'block';

            let leftPos = event.pageX + 10;
            let topPos = event.pageY + 10;

            if (leftPos + tooltipWidth + 10 > windowWidth) {
              leftPos = windowWidth - tooltipWidth - 10;
            }
            
            
            setTooltipPosition(tooltip, topPos + 'px', 'auto', leftPos + 'px', `translateX(0)`);
          } else if(isTouchDevice()) {
            item.style.position = 'relative';
            tooltip.style.display = 'block';
            setTooltipPosition(tooltip, '100%', 'auto', '50%', `translateX(-50%)`);

            const tooltipRect = tooltip.getBoundingClientRect();

            if(tooltipRect.right > windowWidth) {
              setTooltipPosition(tooltip, '100%', '0', 'auto', `translateX(0)`);
            } else if(tooltipRect.left < 10) {
              setTooltipPosition(tooltip, '100%', 'auto', '0', `translateX(0)`);
            }
          }
        });

        item.addEventListener('mouseout', () => {
          tooltip.style.display = 'none';
        });
      }
    });

    function setTooltipPosition(tooltip, setTop, setRight, setLeft, setTransform) {
      tooltip.style.top = setTop;
      tooltip.style.right = setRight;
      tooltip.style.left = setLeft;
      tooltip.style.transform = setTransform;
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            const hasScrollbar = !!this.dataset.hasScrollbar;
            const swiperOptions = {
              slidesPerView: 4,
              spaceBetween: 40,
              watchSlidesProgress: true,
              shortSwipes:false,
              longSwipesRatio: 0.1,
              longSwipesMs: 5,
              a11y:false,
              scrollbar: hasScrollbar && {
                el: ".swiper-scrollbar",
                draggable: true,
              },
              loop: !hasScrollbar,
              breakpoints: {
                320: {
                  slidesPerView: 1.1,
                  slidesPerGroup: 1,
                  spaceBetween: 32,
                },
                721: {
                  slidesPerView: 2.1,
                  spaceBetween: 32,
                },
                1024: {
                  slidesPerView: 2.8,
                  spaceBetween: 32,
                },
                1280: {
                  slidesPerView: 4,
                  spaceBetween: 32,
                },
                1600: {
                  slidesPerView: 5.2,
                  spaceBetween: 32,
                },
                2200: {
                  slidesPerView: 7.1,
                  spaceBetween: 32,
                },
              },
            };
            if(this.querySelector('.swiper')) this.swiper = new Swiper(this.querySelector(".swiper"), swiperOptions);
          });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class PortfolioDropdown extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.bindEvents();
  }

  bindEvents() {
    const toggleButton = this.querySelector('button');
    toggleButton.addEventListener('click', () => {
      if (this.isOpen) {
        this.hideDropdown();
      } else {
        this.showDropdown();
      }
    });

    document.addEventListener("click", (e) => {
      const hasClickedInElement = [
        this,
        this.querySelector('button'),
        this.querySelector('button span')
      ].includes(e.target);
      if (!hasClickedInElement) {
        this.hideDropdown();
      }
    });
  }

  hideButton() {
    requestAnimationFrame(callback.bind(this));

    function callback() {
      this.classList.add('hide');
    }
  }

  showButton() {
    requestAnimationFrame(callback.bind(this));

    function callback() {
      this.classList.remove('hide');
    }
  }

  hideDropdown() {
    requestAnimationFrame(callback.bind(this));

    function callback() {
      this.classList.remove('active');
      const toggleButton = this.querySelector('button');
      toggleButton.setAttribute('aria-expanded', 'false');
      this.isOpen = false;
    }
  }

  showDropdown() {
    requestAnimationFrame(callback.bind(this));

    function callback() {
      this.classList.add('active');
      const toggleButton = this.querySelector('button');
      toggleButton.setAttribute('aria-expanded', 'true');
      this.isOpen = true;
    }
  }
}

customElements.define('portfolio-dropdown', PortfolioDropdown);

class SearchToggle extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.parentElement.tagName.toLowerCase() !== 'summary') {
        document.querySelector('.search-details details').setAttribute('open', '');
      }

      const stickyHeader = document.querySelector('sticky-header');
      if (stickyHeader) {
        stickyHeader.setAttribute('searchopen', '');
        document.body.classList.add('prevent-scroll');
      }

      const input = document.querySelector('.search__field-input.real-input');
      input.focus();
    });

    document.querySelector('.search-modal__close-button').addEventListener('click', () => {
      const stickyHeader = document.querySelector('sticky-header');
      if (stickyHeader) {
        stickyHeader.removeAttribute('searchopen');
        document.body.classList.remove('prevent-scroll');
      }
    })
  }
}

customElements.define('search-toggle', SearchToggle);

class DesktopHeaderSearch extends HTMLElement {
  connectedCallback() {
    const input = this.querySelector('.search__field-input.real-input');
    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      // shows menu on focus
      input.addEventListener('focus', () => {
        if (!stickyHeader.attributes.searchopening) {
          stickyHeader.setAttribute('searchopening', '');
          this.openTransitionTimeout = setTimeout(() => {
            stickyHeader.removeAttribute('searchopening');
            stickyHeader.setAttribute('searchopen', '');
            document.body.classList.add('prevent-scroll');
          }, 130);
        }
      });

      // detect outside click to close search
      document.body.addEventListener("click", (e) => {
        const isOutside = !stickyHeader.contains(e.target);
        if (isOutside) {
          stickyHeader.removeAttribute('searchopen');
          document.body.classList.remove('prevent-scroll');
          stickyHeader.removeAttribute('searchopening');
          clearTimeout(this.openTransitionTimeout);
        }
      });

      // adds close button event
      stickyHeader.querySelector('.header__icon.header__icon--megamenu-close').addEventListener('click', () => {
        if (stickyHeader.hasAttribute('searchopen')) {
          stickyHeader.removeAttribute('searchopen');
          document.body.classList.remove('prevent-scroll');
        }
      });
    }
  }
}

customElements.define('desktop-header-search', DesktopHeaderSearch);

class ColorSwatches extends HTMLElement {
  connectedCallback() {
    const colorSwatches = JSON.parse(this.querySelector('script').innerHTML);
    window.patternTheme.colorSwatches =
        Object.assign(window.patternTheme.colorSwatches, colorSwatches);
  }
}

customElements.define('color-swatches', ColorSwatches);

class ColorPicker extends HTMLElement {
  connectedCallback() {
    this.HIDE_THRESHOLD = 7;

    this.addColorsFromSwatches();
    this.addOuterWrapperItemClickEvent();

    if (this.classList.contains('small')) {
      this.sortRadiosByOutOfStock();
      this.addColorCollapser();
    }
  }

  addColorsFromSwatches() {
    const colorSwatches = window.patternTheme.colorSwatches;
    const radios = Array.from(this.querySelectorAll('input'));

    radios.forEach((radio) => {
      const radioColorName = radio.dataset.color;
      const radioColorObject = colorSwatches[radioColorName];
      const radioColor = radioColorObject && radioColorObject.color;
      const radioColorImage = radioColorObject && radioColorObject.colorImage;
      const radioType = radio.getAttribute('type');

      if(radioType == 'checkbox' && radio.closest('color-picker')) {
        radio = radio.closest('color-picker').querySelector('label');
      }

      const backgroundValue = radioColorImage
          ? `url("${radioColorImage}")`
          : (radioColor || radioColorName);
      const radioStyle = `background: ${backgroundValue}; background-size: contain; background-repeat: no-repeat;`;

      radio.style = radioStyle;
    });
  }

  addOuterWrapperItemClickEvent() {
    const outerWrappers = Array.from(this.querySelectorAll('.outer-wrapper'));

    outerWrappers.forEach((outerWrapper) => {
      outerWrapper.addEventListener('click', () => {
        // this.cleanOuterWrapperActiveStates();
        // outerWrapper.classList.add('active');
      })
    })
  }

  cleanOuterWrapperActiveStates() {
    const outerWrappers = Array.from(this.querySelectorAll('.outer-wrapper'));

    outerWrappers.forEach((outerWrapper) => {
      outerWrapper.classList.remove('active');
    });
  }

  addColorCollapser() {
    const outerWrappers = Array.from(this.querySelectorAll('.outer-wrapper'));


    outerWrappers.forEach((outerWrapper, index) => {
      if (index >= this.HIDE_THRESHOLD) {
        outerWrapper.style.display = 'none';
      }
    });

    if (outerWrappers.length > this.HIDE_THRESHOLD) {
      const collapserButton = document.createElement('button');
      collapserButton.classList.add('color-picker__collapser-button');
      collapserButton.innerHTML = window.themeIcons.arrowDown;
      collapserButton.addEventListener('click', this.toggleCollapser.bind(this));

      this.append(collapserButton);
    }
  }

  sortRadiosByOutOfStock() {
    const inStockRadios = Array.from(this.querySelectorAll("input:not(.out-of-stock)"));
    const outOfStockRadios = Array.from(this.querySelectorAll("input.out-of-stock"));
    const inStockOuterWrappers = inStockRadios.map((radio) => radio.closest('.outer-wrapper'));
    const outOfStockOuterWrappers = outOfStockRadios.map((radio) => radio.closest('.outer-wrapper'));


    this.innerHTML = '';
    inStockOuterWrappers.forEach((el) => this.append(el));
    outOfStockOuterWrappers.forEach((el) => this.append(el));
  }

  toggleCollapser(event) {
    event.preventDefault();
    const collapserButton = this.querySelector('.color-picker__collapser-button');
    const outerWrappers = Array.from(this.querySelectorAll('.outer-wrapper'));

    if (collapserButton.classList.contains('open')) {
      outerWrappers.forEach((outerWrapper, index) => {
        if (index >= this.HIDE_THRESHOLD) {
          outerWrapper.style.display = 'none';
        }
      });

      collapserButton.classList.remove('open');
    } else {
      outerWrappers.forEach((outerWrapper) => {
        outerWrapper.style.display = 'block';
      });

      collapserButton.classList.add('open');
    }
  }
}

customElements.define('color-picker', ColorPicker);
customElements.define('message-toast', class MessageToast extends HTMLElement {
  connectedCallback() {
    window.patternTheme.toast = {
      success: this.success.bind(this),
      error: this.error.bind(this)
    }
  }

  success(message) {
    this.sendMessage('success', message);
  }

  error(message) {
    this.sendMessage('error', message);
  }

  sendMessage(messageType, message) {
    const DISMISS_TIME = 5000;
    const toastText = this.querySelector('.toast-text');
    const toastWrapper = this;
    toastText.innerHTML = message;
    toastWrapper.classList.add('open');
    toastWrapper.classList.add(messageType);

    setTimeout(() => {
      const CLOSE_ANIMATION_TIME = 400;
      toastWrapper.classList.remove('open');
      setTimeout(() => toastWrapper.classList.remove(messageType), CLOSE_ANIMATION_TIME);
    }, DISMISS_TIME);
  }
});

customElements.define('custom-checkbox', class CustomCheckbox extends HTMLElement {
  connectedCallback() {
    this.addEventListener('mousedown', () => this.classList.add('pressed'));
    this.addEventListener('mouseup', () => this.classList.remove('pressed'));
    this.addEventListener('mouseleave', () => this.classList.remove('pressed'));
  }
});

class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('.js-video')
    this.toggle = this.querySelector('.js-video-toggle')

    this.toggle.addEventListener('click', this.toggleClick.bind(this))
  }

  toggleClick() {
    this.video.classList.contains('pause') ? this.play() : this.pause()
  }

  play() {
    this.video.classList.remove('pause')
    this.toggle.classList.remove('pause')
    this.video.play()
  }

  pause() {
    this.video.classList.add('pause')
    this.toggle.classList.add('pause')
    this.video.pause()
  }
}

customElements.define("custom-video", CustomVideo);

function videoLazyLoad() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
}

document.addEventListener("DOMContentLoaded", videoLazyLoad);
document.addEventListener("shopify:section:load", videoLazyLoad);

document.addEventListener("DOMContentLoaded", function () {
  let criticalCSS = document.querySelector('.js-critical-css')

  if(criticalCSS) {
    criticalCSS.remove()
  }
});

function sticky() {
  let stickyWrapper = document.querySelector('.js-sticky-widget')

  if(stickyWrapper) {
    new Sticksy('.js-sticky-widget', {topSpacing: 150})
  }
}

sticky()

